module.exports = __webpack_public_path__ + "img/IsopartnerLogo-White.02215581.png";